// ─── I pezzi che tutte le schermate delle Impostazioni si dividono ───────────

import { useQueryClient } from '@tanstack/react-query';
import type { Permesso } from '@pmo/shared';
import { useSessione } from '../../features/auth/sessione.js';

/**
 * Se questo accesso può CAMBIARE, non solo guardare.
 *
 * ⚖️ Due condizioni, e la seconda non è ridondante: un `readonly` può avere la
 * spunta — le spunte e il ruolo sono due assi diversi — ma il server gli rifiuta
 * ogni scrittura per METODO (`SOLA_LETTURA`). Mostrargli «Salva» vorrebbe dire
 * offrirgli un gesto che finisce in un errore.
 * 📌 Il freno vero resta quello del server: qui si evita di prendere in giro chi
 *    guarda, non si difende niente.
 */
export function usaModifica(permesso: Permesso): boolean {
  const { profilo } = useSessione();
  return (profilo?.permissions.includes(permesso) ?? false) && profilo?.role !== 'readonly';
}

/** Rilegge un elenco dopo una modifica: una schermata che resta ferma mente. */
export function usaRilettura(chiave: string): () => void {
  const qc = useQueryClient();
  return () => void qc.invalidateQueries({ queryKey: [chiave] });
}

export function SoloLettura({ mostra }: { mostra: boolean }): React.JSX.Element | null {
  if (mostra) return null;
  return <p className="tenue">Questo accesso può guardare, non cambiare.</p>;
}

/** L'euro dall'importo in centesimi: mai una divisione a mano, mai un `toFixed`. */
export function euro(cents: number): string {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}
